import React from 'react';

function About() {
  return (
    <div>
      <h1>Sobre o StradData</h1>
      <p>O StradData é um blog que fala sobre dados e tecnologia.</p>
    </div>
  );
}

export default About;
